import { API, graphqlOperation } from 'aws-amplify';
import gql from 'graphql-tag';
import { StageCategoryPartial } from '../../_types/types.type';

interface ListCategoryByOrgResponse {
  listStageCategorys: {
    items: StageCategoryPartial[];
    nextToken: string | null;
  };
}

interface ListCategoryByOrgVariables {
  orgID: string;
  nextToken: string | null;
}

const fetchCategoriesQuery = gql`
  query ListStageCategorys($orgID: ID!, $nextToken: String) {
    listStageCategorys(
      filter: { orgID: { eq: $orgID }, isDeleted: { eq: false } }
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        title
        isDefault
        enablePindrop
        enableDeal
        flexAttributes
        createdAt
        updatedAt
        isDeleted
        dispositions(filter: { isDeleted: { eq: false } }) {
          items {
            id
            iconName
            isDeleted
            orgID
            title
            categoryID
            order
            isSetupDeal
            isConversation
            isDefault
            noRecording
            isNotSelectable
            commentsAtTop
            requireDate
          }
        }
        stages(filter: { isDeleted: { eq: false } }) {
          items {
            id
            title
            isDeleted
            isActive
            isNoDealDefault
            isDisplay
            isMapDefault
            requireCloser
            sendToCRM
            userSelectable
            flexAttributes
            sequence
            orgID
            userSelectable
            changeToDispositionID
            setStages
            sendToCRM
          }
        }
      }
      nextToken
    }
  }
`;

const fetchCategories = async (): Promise<any> => {
  try {
    let categories: StageCategoryPartial[] = [];
    let nextToken = null;
    do {
      const categoriesRes = (await API.graphql(
        graphqlOperation(fetchCategoriesQuery, {
          // @ts-ignore
          orgID: global.me.orgID,
          nextToken,
        } as ListCategoryByOrgVariables)
      )) as { data: ListCategoryByOrgResponse };
      console.log('categoriesRes', categoriesRes);
      const possibleCategoryItems =
        categoriesRes.data?.listStageCategorys?.items ?? [];
      const categoryItems = [];
      for (const category of possibleCategoryItems) {
        if (category.enableDeal || category.enablePindrop) {
          //
          //  Don't include categories that aren't visible to the user
          //
          if (
            category.flexAttributes &&
            typeof category.flexAttributes === 'string'
          ) {
            category.flexAttributes = JSON.parse(
              category.flexAttributes as string
            );
          }
          const dispositionOrder = category.flexAttributes?.dispositionOrder;
          if (dispositionOrder) {
            console.log('dispositionOrder:::', dispositionOrder);
            // @ts-ignore
            category.dispositions = category.dispositions?.items?.sort(
              (a: any, b: any) =>
                dispositionOrder.indexOf(a.id) - dispositionOrder.indexOf(b.id)
            );
          } else {
            // @ts-ignore
            category.dispositions = category.dispositions?.items?.sort(
              (a: any, b: any) => a.order - b.order
            );
            category.flexAttributes.dispositionOrder =
              category.dispositions?.map((item: any) => item.id);
          }

          if (category.stages) {
            // @ts-ignore
            category.stages = category.stages?.items?.sort(
              (a: any, b: any) => a.sequence - b.sequence
            );
          }

          categoryItems.push(category);
        }
      }
      categories = [...categories, ...categoryItems];
      nextToken = categoriesRes.data?.listStageCategorys?.nextToken;
    } while (nextToken);

    return categories;
  } catch (err) {
    console.error('Error fetching categories:', err);
    throw new Error('Error fetching categories');
  }
};

export default fetchCategories;
